import { fetchApi } from './api';
import type {
    AppUsageStats, AppUsagePagesResponse, AppUsagePageDetail,
    AppUsageUsersResponse, AppUsageUserDetail, AppUsageAiResponse, UsageWindow, UsageAppScope,
} from '../types/appUsage';

const win = (w: UsageWindow) => `window=${w}`;
const scope = (app: UsageAppScope) => `app=${encodeURIComponent(app)}`;

export function getAppUsageStats(w: UsageWindow, app: UsageAppScope): Promise<AppUsageStats> {
    return fetchApi<AppUsageStats>(`/app-usage/stats?${win(w)}&${scope(app)}`);
}

export function getAppUsagePages(w: UsageWindow, app: UsageAppScope): Promise<AppUsagePagesResponse> {
    return fetchApi<AppUsagePagesResponse>(`/app-usage/pages?${win(w)}&${scope(app)}`);
}

/** `app` is the row's own app, never 'all' — the same path exists in several apps. */
export function getAppUsagePageDetail(page: string, w: UsageWindow, app: UsageAppScope): Promise<AppUsagePageDetail> {
    return fetchApi<AppUsagePageDetail>(`/app-usage/page-detail?page=${encodeURIComponent(page)}&${win(w)}&${scope(app)}`);
}

export function getAppUsageUsers(w: UsageWindow, app: UsageAppScope): Promise<AppUsageUsersResponse> {
    return fetchApi<AppUsageUsersResponse>(`/app-usage/users?${win(w)}&${scope(app)}`);
}

export function getAppUsageUserDetail(email: string, w: UsageWindow, app: UsageAppScope): Promise<AppUsageUserDetail> {
    return fetchApi<AppUsageUserDetail>(`/app-usage/user-detail?email=${encodeURIComponent(email)}&${win(w)}&${scope(app)}`);
}

/** [Reporting].[AiCallLog] holds the Reporting App's and Customer 360's calls, apart by host. */
export function getAppUsageAi(w: UsageWindow, app: UsageAppScope): Promise<AppUsageAiResponse> {
    return fetchApi<AppUsageAiResponse>(`/app-usage/ai?${win(w)}&${scope(app)}`);
}
